var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'c-nav-four-column-grid',
    'l-grid',
    'l-grid--4-col',
    'l-grid--4-col-min-2',
  ]},_vm._l((_vm.navItems),function(item){return _c('div',{key:item.id},[_vm._t("item",function(){return [(item.contentType)?_c(item.contentType,_vm._b({tag:"component",attrs:{"id":item.handle}},'component',item.data,false)):_vm._e()]},{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }